import { createIamClient, SearchOperation, searchRequestFactory } from '@infuse/api/common';
import { AccessType } from './access-type';

export interface Permission {
  id: string;
  domain: string;
  subscriptionId: string;
  subscriptionName: string;
  permissionId: string;
  category: string;
  objectType: string;
  accessType: AccessType;
  name: string;
  description: string;
  bulkAction: boolean;
  createdAt: Date;
}

const client = createIamClient('/rest/permissions');

export const permissionPermissions = {
  SEARCH: 'iam.search-permissions'
};

// no pagination or filtering available for this api, so we opt for a simple get all request
export const searchPermissions: SearchOperation<Permission> = searchRequestFactory<Permission>(client, {
  permissionId: permissionPermissions.SEARCH
});
